import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Chip,
  Alert,
  AlertTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import moment from 'moment';

function VerificaCorrelatividad({ faltantes, datosFaltantes }) {

// console.log("datosFaltantes", datosFaltantes);
// console.log("faltantes", faltantes);


  // Si no hay faltantes, no mostrar nada
  if (!faltantes || faltantes.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          border: '1px solid #ff9800',
          backgroundColor: '#fff8e1',
          borderRadius: 1
        }}
      >
        <Alert 
          severity="warning" 
          icon={<WarningIcon />}
          sx={{ mb: 2 }}
        >
          <AlertTitle sx={{ fontWeight: 'bold' }}>
            Faltan {faltantes.length} comprobante{faltantes.length > 1 ? 's' : ''}
          </AlertTitle>
          Números faltantes: <strong>{faltantes.join(', ')}</strong>
        </Alert>

        {datosFaltantes && datosFaltantes.length > 0 && (
          <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell><strong>N° Comprobante</strong></TableCell>
                  <TableCell><strong>Fecha</strong></TableCell>
                  <TableCell><strong>Rendición</strong></TableCell>
                  <TableCell><strong>Chofer</strong></TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
                {datosFaltantes.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      <Chip 
                        label={row.pto_venta+"-"+row.nro_comprobante} 
                        size="small" 
                        color="warning" 
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>{moment(row.fecha_rendicion).format("DD-MM-YYYY")}</TableCell>
                    <TableCell>{row.nro_rendicion}</TableCell>
                    <TableCell >{row.nombre_apellido}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {(!datosFaltantes || datosFaltantes.length === 0) && (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
             No se encontraron datos en la base de datos para estos números.
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

export default VerificaCorrelatividad;